import React from "react";

const COLORS = {
  PENDING: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30", dot: "bg-slate-400" },
  RUNNING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30", dot: "bg-amber-400" },
  SUCCESS: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30", dot: "bg-emerald-400" },
  READY: { bg: "bg-emerald-500/20", text: "text-emerald-200", border: "border-emerald-400/40", dot: "bg-emerald-400" },
  PREPARING: { bg: "bg-cyan-500/15", text: "text-cyan-300", border: "border-cyan-500/30", dot: "bg-cyan-400" },
  WORKSPACE: { bg: "bg-cyan-500/15", text: "text-cyan-300", border: "border-cyan-500/30", dot: "bg-cyan-400" },
  DATABASE: { bg: "bg-indigo-500/15", text: "text-indigo-300", border: "border-indigo-500/30", dot: "bg-indigo-400" },
  SEEDING: { bg: "bg-violet-500/15", text: "text-violet-300", border: "border-violet-500/30", dot: "bg-violet-400" },
  ADMIN: { bg: "bg-purple-500/15", text: "text-purple-300", border: "border-purple-500/30", dot: "bg-purple-400" },
  CONFIGURATION: { bg: "bg-sky-500/15", text: "text-sky-300", border: "border-sky-500/30", dot: "bg-sky-400" },
  ENVIRONMENT: { bg: "bg-teal-500/15", text: "text-teal-300", border: "border-teal-500/30", dot: "bg-teal-400" },
  VERIFYING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30", dot: "bg-amber-400" },
  FAILED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30", dot: "bg-rose-400" },
  CANCELLED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30", dot: "bg-neutral-400" },
};

const IN_PROGRESS_STATES = new Set([
  "PREPARING", "WORKSPACE", "DATABASE", "SEEDING", "ADMIN",
  "CONFIGURATION", "ENVIRONMENT", "VERIFYING", "RUNNING",
]);

export function ProvisionStatusBadge({ status, size = "md" }) {
  const key = String(status || "PENDING").toUpperCase();
  const c = COLORS[key] || COLORS.PENDING;
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  const pulse = IN_PROGRESS_STATES.has(key) ? "animate-pulse" : "";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border font-black uppercase tracking-wider ${cls} ${c.bg} ${c.text} ${c.border}`}
      data-testid={`provision-status-${key.toLowerCase()}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${c.dot} ${pulse}`} /> {key}
    </span>
  );
}
